const PAGE_PREFIX = '/page'

export const signIn = `${PAGE_PREFIX}/signin`
export const reg = `${PAGE_PREFIX}/reg`
export const forgotPwd = `${PAGE_PREFIX}/forgotPwd`
export const resetPwd = `${PAGE_PREFIX}/resetPwd`
export const resetPwdExpired = `${PAGE_PREFIX}/resetPwd/expired`
export const updatePassword = `${PAGE_PREFIX}/updatePassword`
export const verify = `${PAGE_PREFIX}/verify`
export const verificationDeclined = `${PAGE_PREFIX}/verificationDeclined`
export const userProfile = `${PAGE_PREFIX}/userProfile`
